export const INITIAL_PLAN_WEEKLY_SPEND_OPPS = 'initial_plan_weekly_opps';
export const INITIAL_PLAN_MONTHLY_SPEND_OPPS = 'initial_plan_monthly_opps';
export const INITIAL_PLAN_WEEKLY_HEADERS_OPPS = 'initial_plan_opps_column_headers_weekly';
export const INITIAL_PLAN_DOWNLOAD_FILE_WEEKLY_OPPS = 'initial_plan_opps_weekly.xlsx';
export const INITIAL_PLAN_DOWNLOAD_FILE_MONTHLY_OPPS = 'initial_plan_opps_monthly.xlsx';
export const DATA_KEY_OPPS = 'opps';

// Graph overtime download constants
export const INITIAL_PLAN_OPPS_OVERTIME_WEEKLY_DOWNLOAD =
  'initial_plan_opportunities__overtime_weekly_download';
export const INITIAL_PLAN_OPPS_OVERTIME_MONTHLY_DOWNLOAD =
  'initial_plan_opportunities__overtime_monthly_download';
export const INITIAL_PLAN_OPPS_OVERTIME_WEEKLY_FILE =
  'initial_plan_opportunities__overtime_weekly_graph.xlsx';
export const INITIAL_PLAN_OPPS_OVERTIME_MONTHLY_FILE =
  'initial_plan_opportunities__overtime_monthly_graph.xlsx';
